import { Component } from '@angular/core';
import { Router, RouterEvent } from '@angular/router';
import { Location } from "@angular/common";

import { WindowRef } from './window/service/window.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'MERENDA';
  routerPath = '';


  constructor(private winRef: WindowRef, private router: Router, private location: Location) {
    router.events.subscribe(val => {
      if (val['routerEvent']) {
        this.routerPath = val['routerEvent'].url;
      }
    });
  }

}
